import { render, staticRenderFns } from "./RewardCenter.vue?vue&type=template&id=fedff8c8&scoped=true"
import script from "./RewardCenter.vue?vue&type=script&lang=js"
export * from "./RewardCenter.vue?vue&type=script&lang=js"
import style0 from "./RewardCenter.vue?vue&type=style&index=0&id=fedff8c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedff8c8",
  null
  
)

export default component.exports